import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="18" height="18" rx="9" fill="black" />
    <path
      d="M6.1986 9.50002C6.1986 10.4538 6.1986 11.3783 6.1986 12.327C8.33871 12.327 10.4477 12.327 12.5758 12.327C12.5758 12.8634 12.5758 13.3755 12.5758 13.9065C9.82769 13.9065 7.08508 13.9065 4.32495 13.9065C4.32495 11.1956 4.32495 8.48714 4.32495 5.75916C4.93564 5.75916 5.55226 5.75916 6.1986 5.75916C6.1986 6.99797 6.1986 8.23435 6.1986 9.50002Z"
      fill="#FBFBFB"
    />
    <path
      d="M11.2182 4.78476C11.8861 4.14568 12.7444 4.04641 13.4583 4.51208C14.127 4.94833 14.364 5.76828 14.0201 6.45627C13.6082 7.28048 12.5293 7.61869 11.7013 7.1832C10.8199 6.71962 10.5549 5.70085 11.1126 4.91924C11.1415 4.87876 11.1728 4.8398 11.2182 4.78476Z"
      fill="#FDFDFD"
    />
  </svg>
)
